import { render } from "./GButton.vue?vue&type=template&id=521c6b6a"
import script from "./GButton.vue?vue&type=script&lang=js"
export * from "./GButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__